/**
 * input要素にイベントリスナを登録し入力値のバリデーションを行う
 * validateMapに登録された全項目がtrueの時、送信可能にする
 */
export default class ReservationForm {
  constructor() {
    this.formEl = document.getElementById("reservationForm"); // HTMLFormElement 子にinputを含むフォーム要素
    this.submitButtonEl; // HTMLButtonElement 送信ボタン要素
    this.recaptchaInput; // recaptchaのcallbackによりclassList, checkedが変更されるinput要素
    this.inputNodeMap = {}; // {[key: name属性値]: input要素}
    this.requiredMap = {}; // {[key: name属性値]: boolean} 必須項目のマップ
    this.validateMap = {}; // {[key: name属性値]: boolean} 各項目のバリデーション状態に対応するマップ
    this.recaptchObserver;

    this.rentalGoodsValiations = document.getElementById(
      "rentalGoodsValiations"
    ); // レンタル品のinputフィールドを持つ要素

    if (this.formEl !== null) {
      this.init();
    }
  }

  /**
   * 初期化
   * 1) イベントリスナの登録
   * 2) 要素と必須項目をマッピング
   * 3) 予約日時の上下限を登録
   * @returns {void}
   */
  init() {
    this.formEl.querySelectorAll("input").forEach((inputEl) => {
      inputEl.addEventListener("change", () => {
        this.inputEeventHandler(inputEl);
      });
      this.inputNodeMap[inputEl.name] = inputEl;
      this.requiredMap[inputEl.name] = inputEl.required;
      this.validateMap[inputEl.name] = !inputEl.required;
    });

    this.observeRecaptcha();

    this.submitButtonEl = this.formEl.querySelector("#submitButton");
    this.submitButtonEl.addEventListener("click", () => {
      try {
        this.submitBtnInProgress(true);
        this.formEl.submit();
        this.recaptchObserver.disconnect();
      } catch (e) {
        this.submitBtnInProgress(false);
      }
    });

    this.validateAllOnLoaded();
  }

  /**
   * recaptchaのコールバックによるclassList操作を監視し、
   * input要素のchecked属性値をバリデーションする
   * @returns {void}
   */
  observeRecaptcha() {
    this.recaptchaInput = document.getElementById("isVerified");
    this.recaptchObserver = new MutationObserver((records) => {
      this.validateMap["isVerified"] = this.validate(
        "isVerified",
        records[0].target.checked
      );
      this.submitButtonEl.disabled = !this.isValidatedAll();
    });
    // クラス名の変更を監視
    this.recaptchObserver.observe(this.recaptchaInput, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  /**
   * インプットElementのイベント発生時に行う処理
   * 1. 入力値のバリデーション
   * 2. エラーメッセージ判定
   * 3. 全必須項目の状態を確認
   * 4. UI上でレンタル品選択項目を出し分ける
   * @param {HTMLElement} el
   * @returns {void}
   */
  inputEeventHandler(el) {
    // 1
    if (
      el.name === "privacy" ||
      el.name === "isVerified" ||
      el.name === "rental" ||
      el.name === "isWearSelected"
    ) {
      this.validateMap[el.name] = this.validate(el.name, el.checked);
    } else if (
      el.name === "upperWear" ||
      el.name === "bottomWear" ||
      el.name === "towel" ||
      el.name === "socks"
    ) {
      this.isSelectedAny();
    } else {
      this.validateMap[el.name] = this.validate(el.name, el.value);
    }
    this.toggleRentalItems(el.id); // 4
    this.toggleAlert(el.name); // 2
    this.submitButtonEl.disabled = !this.isValidatedAll(); // 3
  }
  
  /**
   * UI上でレンタル品選択項目を出し分ける
   * @param {string} id input要素のID
   * @returns {void}
   */
  toggleRentalItems(id) {
    if (id === "needRental") {
      this.rentalGoodsValiations.classList.add("show");
      this.isSelectedAny();
    } else if (id === "unneedRental") {
      this.rentalGoodsValiations.classList.remove("show");
      this.validateMap["isWearSelected"] = true;
    }
  }

  /**
   * エラーメッセージ表示用クラスを付与
   * @param {string} name input要素のname属性値
   */
  toggleAlert(name) {
    if (!this.validateMap[name]) {
      this.inputNodeMap[name].classList.add("js-invalid");
    } else {
      this.inputNodeMap[name].classList.remove("js-invalid");
    }
  }

  /**
   * 入力値のバリデーション
   * @param {string} name input要素のname属性値
   * @param {string} value input要素のvalue値, privacyのみchecked属性
   * @returns boolean
   */
  validate(name, value) {
    switch (name) {
      case "userName":
        return value.length > 0;
      case "userEmail":
        return /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}.[A-Za-z0-9]{1,}$/.test(
          value
        );
      case "userTelphone":
        return /^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7})$/.test(value);
      case "rental":
        return true;
      case "isWearSelected":
      case "privacy":
      case "isVerified":
        return value;
      default:
        console.log(`"${name}": parameter is undefind.`);
        return true;
    }
  }

  /**
   * 1. レンタル品が最低限１つ選択されているか判定
   * 2. 判定に応じてエラーメッセージを出し分け
   * @returns {void}
   */
  isSelectedAny() {
    let flag = false;
    this.rentalGoodsValiations
      .querySelectorAll(".c-rentalField input")
      .forEach((inputEl) => {
        if (inputEl.checked) {
          flag = true;
          this.validateMap["isWearSelected"] = true; // 1
          this.inputNodeMap["isWearSelected"].classList.remove("js-invalid"); // 2
        }
      });
    if (!flag) {
      this.validateMap["isWearSelected"] = false; // 1
      this.inputNodeMap["isWearSelected"].classList.add("js-invalid"); // 2
    }
  }

  /**
   * 初期読み込み時に全項目をバリデーション
   * rentalはradioのため、input後は常にtrue、ロード時のみfalseとする
   * @returns {void}
   */
  validateAllOnLoaded() {
    Object.entries(this.requiredMap)
      .filter(([key, bool]) => {
        return bool;
      })
      .map(([key, bool]) => {
        return key;
      })
      .forEach((key) => {
        if (
          key === "privacy" ||
          key === "isVerified" ||
          key === "isWearSelected"
        ) {
          this.validateMap[key] = this.validate(
            key,
            this.inputNodeMap[key].checked
          );
        } else if (key === "rental") {
          this.validateMap[key] = false;
        } else {
          this.validateMap[key] = this.validate(
            key,
            this.inputNodeMap[key].value
          );
        }
      });
  }

  /**
   * 全項目がバリデーションを通っているか判定
   * @returns boolean
   */
  isValidatedAll() {
    return Object.values(this.validateMap).every((flag) => flag);
  }

  /**
   * 送信ボタンの複数回クリックを抑止する目的で実装
   * @param {boolean} bool true: クリック不可, false: クリック可
   */
  submitBtnInProgress(bool) {
    if (bool) {
      this.submitButtonEl.disabled = true;
      this.submitButtonEl.classList.add("js-inprogress");
    } else {
      this.submitButtonEl.disabled = false;
      this.submitButtonEl.classList.remove("js-inprogress");
    }
  }
}
